import React from "react";
import * as Mui from "@mui/material";
import { DashboardLayout } from "component/layout/dashboard";
import { PageProps } from "shared/page-props";
import * as Router from "react-router-dom";
import * as Icons from "react-feather";
import { FeatherIcon } from "component/shared/feather-icon";
import { LeadImportContent } from "component/shared/lead-import-content";

interface Props extends PageProps, Router.RouteComponentProps {}

const LeadImportPageComponent: React.FC<Props> = ({ user }) => {
	const title = "Import Leads";

	return (
		<DashboardLayout
			permitted={user && user.permissions.leads}
			title={title}
			header={
				<Mui.Typography variant="h1">
					<FeatherIcon>
						<Icons.User />
					</FeatherIcon>
					{title}
				</Mui.Typography>
			}
		>
			<LeadImportContent user={user} />
		</DashboardLayout>
	);
};

export const LeadImportPage = LeadImportPageComponent;
